module.exports = __webpack_public_path__ + "img/13.71f0352.jpg";